import ModalSpeakers from "../ModalSpeakers";
import HeroResponsiveCarousel from "../HeroResponsiveCarousel";
import ContentFilter from "../ContentFilter";

class TemplateHub {
    constructor(el) {
        this.el = el;
        this.init();
        this.initFilter();
    }

    init() {
        const heroEl = this.el.querySelector('.responsive-carousel');
        if (heroEl) {
            const carousel = new HeroResponsiveCarousel(heroEl);
        }


        const speakersEls = this.el.querySelectorAll('.event-speaker');
        if (speakersEls.length) {
            const modalSpeakers = new ModalSpeakers();
        }
    }

    initFilter() {
        this.filterSections = this.el.querySelectorAll('.content-filter-enabled');
        if (this.filterSections.length > 0) {
            this.filterSections.forEach((el) => {
                const filter = new ContentFilter(el);
            });
        }
    }
}

export default TemplateHub;
